module.exports = __webpack_public_path__ + "media/recipes/35-364651b0.png";